module.exports = __webpack_public_path__ + "static/assets/840883a021f8c682f2df4f4b1194df2e.svg";